export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/currentaccount_icon@3x.png";